function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.973 25.024c-3.665 0-3.973 0-3.973-.977v-6.904c0-.574.445-1.836.916-1.836h13.762a1.069 1.069 0 001.012-.76l1.52-4.882A.924.924 0 0118.077 9h13.88a.924.924 0 01.878.67l1.521 4.88a1.069 1.069 0 001.011.76h13.705a.951.951 0 01.917.978v8.744l-46.016-.008zm-1.076-7.752c-.586 0-.966.141-.966 1.076v.57c-.023.434.03 3.392.03 3.768 0 .723 1.308.38 3.992.38H47.43a.76.76 0 00.741-.737V18.39a1.102 1.102 0 00-1.068-1.14h-13.15a.92.92 0 01-.87-.666l-1.521-4.877a1.08 1.08 0 00-1.015-.76H19.522a1.08 1.08 0 00-1.015.76l-1.521 4.877a.92.92 0 01-.882.689H2.897z",
  fill: "#00B06A"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.996 13.676h-7.93a.992.992 0 000 1.985h7.93a.992.992 0 100-1.985z",
  fill: "#00B06A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.061 15.585a.916.916 0 110-1.833h7.935a.916.916 0 010 1.832H21.06zM49.084 52.628a.878.878 0 01-.913-.832v-30.87a.92.92 0 011.829 0v30.877a.878.878 0 01-.916.825zM.977 52.834a.879.879 0 01-.912-.833v-30.87a.92.92 0 011.828 0V52.01a.878.878 0 01-.916.825z",
  fill: "#00B06A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9 46.9a9.797 9.797 0 01-8.813-5.464c-1.798-3.604-1.239-7.782 1.521-11.458a.956.956 0 01.198-.194c2.22-1.677 4.668-2.562 7.082-2.562a9.793 9.793 0 018.809 5.466c1.798 3.604 1.24 7.779-1.52 11.455a.956.956 0 01-.195.198c-2.231 1.672-4.68 2.558-7.082 2.558zm0-17.842a7.983 7.983 0 00-7.166 4.436c-1.464 2.924-1.023 6.311 1.212 9.292.066.088.144.166.232.232a9.565 9.565 0 005.703 2.056 7.984 7.984 0 007.166-4.436c1.464-2.927 1.019-6.315-1.213-9.295a8.136 8.136 0 00-.661-.536 8.048 8.048 0 00-5.273-1.75z",
  fill: "#FFA9D3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36.66 40.06c-4.152 3.015-8.782-1.616-5.767-5.767.063-.09.14-.168.228-.232 4.151-3.015 8.786 1.615 5.767 5.767-.063.09-.14.167-.228.232zm-1.464-4.562c-2.026-1.38-4.239.832-2.859 2.859.067.097.15.18.247.247 2.027 1.38 4.24-.833 2.86-2.859a.953.953 0 00-.248-.224v-.023z",
  fill: "#FFA9D3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9 40.95a3.879 3.879 0 01-3.471-2.13c-.715-1.398-.521-3.04.532-4.482a.873.873 0 01.213-.213 4.67 4.67 0 012.726-.954 3.882 3.882 0 013.467 2.13c.715 1.402.52 3.04-.532 4.485a.941.941 0 01-.213.213 4.65 4.65 0 01-2.722.95zm0-5.946a2.053 2.053 0 00-1.821 1.098 2.182 2.182 0 00.205 2.308c.07.105.161.195.266.266.394.282.865.437 1.35.445a2.06 2.06 0 001.82-1.099 2.197 2.197 0 00-.204-2.311 1.057 1.057 0 00-.27-.266 2.407 2.407 0 00-1.346-.441z",
  fill: "#FFA9D3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.885 29.13a.992.992 0 00-1.985 0v3.965a.992.992 0 101.985 0V29.13z",
  fill: "#FFA9D3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9 34a.916.916 0 01-.916-.916V29.13a.916.916 0 111.828 0v3.965A.916.916 0 0133.9 34zM41.822 36.068h-3.965a.992.992 0 000 1.985h3.965a.992.992 0 100-1.985z",
  fill: "#FFA9D3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M37.857 37.977a.916.916 0 110-1.829h3.965a.916.916 0 110 1.829h-3.965zM34.885 41.03a.992.992 0 00-1.985 0v3.965a.992.992 0 101.985 0v-3.966z",
  fill: "#FFA9D3"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9 45.907a.916.916 0 01-.916-.912v-3.97a.916.916 0 011.828 0v3.97a.916.916 0 01-.912.912zM29.927 36.068h-3.965a.992.992 0 000 1.985h3.965a.992.992 0 100-1.985z",
  fill: "#FFA9D3"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.958 37.977a.916.916 0 010-1.829h3.965a.915.915 0 110 1.829h-3.965z",
  fill: "#FFA9D3"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M48.388 53.008H1.205v-1.52h47.183c.277-.01.548.065.754.207.206.143.33.341.345.553-.015.212-.139.41-.345.553a1.26 1.26 0 01-.754.207z",
  fill: "#00B06A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1.205 53.005c-.76-.449-.865-1 0-1.514h47.278c.127-.01.255.002.376.035a.97.97 0 01.327.159c.095.071.17.158.222.255a.653.653 0 010 .616.783.783 0 01-.222.256.97.97 0 01-.327.158 1.09 1.09 0 01-.377.035s-46.517.448-47.277 0zM20.484 45.842a1.213 1.213 0 01-1.213-1.212v-4.927a1.213 1.213 0 012.425 0v4.942a1.213 1.213 0 01-1.212 1.197zm0-9.036a1.21 1.21 0 01-1.213-1.213V30.65a1.213 1.213 0 012.425 0v4.942a1.213 1.213 0 01-1.212 1.213z",
  fill: "#00B06A"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M20.484 45.785a1.14 1.14 0 01-1.14-1.14v-4.943a1.14 1.14 0 112.28 0v4.943a1.14 1.14 0 01-1.14 1.14zm0-9.036a1.14 1.14 0 01-1.14-1.14v-4.943a1.14 1.14 0 112.28 0v4.942a1.14 1.14 0 01-1.14 1.122v.019zM16.032 36.878a1.213 1.213 0 01-1.213-1.213V33.1a1.213 1.213 0 012.425 0v2.566a1.213 1.213 0 01-1.212 1.213z",
  fill: "#00B06A"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M16.032 36.802a1.14 1.14 0 01-1.14-1.14v-2.567a1.14 1.14 0 012.28 0v2.566a1.14 1.14 0 01-1.14 1.14zM16.032 45.91a1.213 1.213 0 01-1.213-1.212v-4.942a1.213 1.213 0 012.425 0v4.942a1.212 1.212 0 01-1.212 1.213z",
  fill: "#00B06A"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M16.032 45.835a1.14 1.14 0 01-1.14-1.14v-4.943a1.14 1.14 0 012.28 0v4.942a1.14 1.14 0 01-1.14 1.14zM11.675 45.842c-.67 0-1.213-.794-1.213-1.771v-3.753c0-.977.544-1.771 1.213-1.771.67 0 1.213.794 1.213 1.771v3.753c0 .977-.544 1.771-1.213 1.771z",
  fill: "#00B06A"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M11.675 45.785c-.627 0-1.14-.76-1.14-1.695v-3.753c0-.935.509-1.695 1.14-1.695.631 0 1.14.76 1.14 1.695v3.753c-.003.935-.513 1.695-1.14 1.695z",
  fill: "#00B06A"
});

function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

export default __webpack_public_path__ + "static/folder.7f602c83.svg";
export { SvgFolder as ReactComponent };